import { shadows } from '@alison/ui';
import type { SxProps, Theme } from '@mui/material/styles';

export const FILTER_BAR_ROW_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 2,
};

export const addFilterButtonSx = (theme: Theme) => ({
  height: 34,
  minWidth: 0,
  px: 3,
  borderRadius: 1,
  borderStyle: 'dashed',
  borderColor: theme.palette.border.strong,
  fontWeight: 600,
  textTransform: 'none',
  color: 'text.secondary',
  '&:hover': {
    borderStyle: 'dashed',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    bgcolor: 'transparent',
  },
});

export const FILTER_MENU_SLOT_PROPS = {
  paper: {
    sx: (theme: Theme) => ({
      border: '1px solid',
      borderColor: theme.palette.divider,
      borderRadius: 1,
      boxShadow: shadows.dropdown,
      p: 1,
      gap: 3,
    }),
  },
};

export const filterMenuItemSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  m: 0,
  p: 1.5,
  borderRadius: 0.5,
  fontSize: 13,
  color: 'text.primary',
  '&:hover': { bgcolor: 'background.platform' },
};

export const filterOptionItemSx: SxProps<Theme> = {
  ...filterMenuItemSx,
  py: 0.5,
};
